import { render, staticRenderFns } from "./JRBpindahan.vue?vue&type=template&id=556d4d94"
import script from "./JRBpindahan.vue?vue&type=script&lang=js"
export * from "./JRBpindahan.vue?vue&type=script&lang=js"
import style0 from "./JRBpindahan.vue?vue&type=style&index=0&id=556d4d94&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports